import React from "react";

/**
 * TypingDots — pulsing 3-dot animation used inside the "X is typing…" line.
 * Theme: "dark" (white dots, used in studio) or "light" (dark dots, used in admin).
 */
export default function TypingDots({ theme = "dark" }) {
  const dot = theme === "light" ? "bg-gray-500" : "bg-white/70";
  return (
    <span className="inline-flex items-end gap-[3px] h-3" data-testid="typing-dots">
      <span className={`w-1 h-1 rounded-full ${dot} animate-bounce`} style={{ animationDelay: "0ms" }} />
      <span className={`w-1 h-1 rounded-full ${dot} animate-bounce`} style={{ animationDelay: "150ms" }} />
      <span className={`w-1 h-1 rounded-full ${dot} animate-bounce`} style={{ animationDelay: "300ms" }} />
    </span>
  );
}
